import { Button, Input, Modal, Popconfirm, Space, message } from "antd";
import AlarmRuleApi from "../../api/AlarmRuleApi";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Table, { ColumnType } from "antd/es/table";
import AlarmRuleUtils from "./util/AlarmRuleUtils";
import StringUtils from "../../util/StringUtils";
import { AlarmRuleManagementWrapper, TableWrapper, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./AlarmRuleManagement.styled";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import CreateAlarmRuleWizard from "./create-rule-management/CreateAlarmRuleWizard";
import PermissionWrapper from "../../components/permission/PermissionWrapper";

interface AlarmRuleManagementProps {

}

const AlarmRuleManagement: React.FC<AlarmRuleManagementProps> = (props)=> {
    // api
    let alarmRuleApi = new AlarmRuleApi();
    const [messageApi, contextHolder] = message.useMessage();
    let navigate = useNavigate();

    // state
    let [loading, setLoading] = useState(true);
    let [alarmRuleView, setAlarmRuleViews] = useState([]);
    let [openCreateAlarmRuleModal, setOpenCreateAlarmRuleModal] = useState(false);
    let [editingAlarmRuleId, setEditingAlarmRuleId] = useState(null);
    let [searchValue, setSearchValue] = useState("");

    // events
    let onEditAlarmRuleDetails = (alarmRuleView: any)=> {
        setEditingAlarmRuleId(alarmRuleView.alarmRule.id);
        setOpenCreateAlarmRuleModal(true);
    };

    let onAddAlarmRuleClick = ()=> {
        setEditingAlarmRuleId(null);
        setOpenCreateAlarmRuleModal(true);
    };

    let onDeleteAlarmRule = async (alarmRuleView: any)=> {
        await alarmRuleApi.delete(alarmRuleView.alarmRule.id);
        messageApi.open({
            type: 'success',
            content: '删除告警规则成功',
        });
        loadAlarmRuleViews();
    };

    let onInputChange = (e)=> {
        setSearchValue(e.target.value);
    };

    // load alarm rule views
    let loadAlarmRuleViews = async ()=> {
        setLoading(true);
        let alarmRuleViews = (await alarmRuleApi.getAllAlarmRuleViews()).data.data;
        setAlarmRuleViews(alarmRuleViews);
        setLoading(false);
    }

    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '规则名称',
            dataIndex: 'alarmRule.name',
            key: 'alarmRule.name',
            align: 'center',
            render: (text, record, index)=> {
                return <a onClick={()=> onEditAlarmRuleDetails(record)}>{record.alarmRule.name}</a>
            }
        },
        {
            title: '目标类型',
            dataIndex: 'alarmRule.type',
            key: 'alarmRule.type',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{AlarmRuleUtils.getTypeName(record.alarmRule.type)}</span>
            }
        },
        {
            title: '目标名称',
            dataIndex: 'target.name',
            key: 'target.name',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.target?.name)}</span>
            }
        },
        {
            title: '变量名称',
            dataIndex: 'alarmRule.key',
            key: 'alarmRule.key',
            align: 'center',
            render: (text, record, index)=> {
                let deviceTemplate = record.deviceTemplate;
                if (!deviceTemplate) {
                    return <span>N/A</span>
                }
                let configuration = JSON.parse(deviceTemplate.configuration);
                let keyName = configuration.properties.find((e)=> e.key == record.alarmRule.metricKey)?.name;
                return <span>{ keyName }</span>
            }
        },
        {
            title: '规则',
            dataIndex: 'alarmRule.rule',
            key: 'alarmRule.rule',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{ AlarmRuleUtils.getRuleAbbriviation(record.alarmRule) }</span>
            }
        },
        {
            title: '备注',
            dataIndex: 'alarmRule.remarks',
            key: 'alarmRule.remarks',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.alarmRule.remarks)}</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (text, record, index)=> {
                return <Space size="middle">
                    <PermissionWrapper permissionCodePath="alarm-management.alarm-rules.update-alarm-rule">
                        <a onClick={()=> onEditAlarmRuleDetails(record)}>编辑规则</a>
                    </PermissionWrapper>

                    <PermissionWrapper permissionCodePath="alarm-management.alarm-rules.delete-alarm-rule">
                        <Popconfirm
                                title="删除设备模板"
                                description={ <div style={{paddingTop: "10px", paddingBottom: '10px'}}>确认要删除设备模板么?</div> }
                                onConfirm={()=> onDeleteAlarmRule(record)}
                                okText="确定"
                                cancelText="取消"
                            >
                            <a>删除规则</a>
                        </Popconfirm>
                    </PermissionWrapper>
                </Space>
            }
        }
    ];

    let filteredAlarmRuleViews = [].concat(alarmRuleView);
    if (searchValue) {
        filteredAlarmRuleViews = filteredAlarmRuleViews.filter((e)=> {
            if (e.alarmRule.name.indexOf(searchValue)>=0 
            || e.target.name.indexOf(searchValue)>=0) {
                return true;
            }
            return false;
        });
    }

    // effect
    useEffect(()=> {
        loadAlarmRuleViews();
    }, []);
    
    // render
    return (
        <AlarmRuleManagementWrapper>
            {contextHolder}
            <ToolBarWrapper>
                <ToolBarLeftWrapper>
                    <Space size="middle">
                        <PermissionWrapper permissionCodePath="alarm-management.alarm-rules.create-alarm-rule">
                            <Button type="primary" icon={<PlusOutlined />} onClick={onAddAlarmRuleClick}>创建规则</Button>
                        </PermissionWrapper>
                    </Space>
                </ToolBarLeftWrapper>

                <ToolBarRightWrapper>
                    <Input 
                        placeholder="请输入规则名称" 
                        suffix={<SearchOutlined />} 
                        size="middle" 
                        onChange={onInputChange} />
                </ToolBarRightWrapper>

                <Modal open={openCreateAlarmRuleModal} 
                    onClose={()=> setOpenCreateAlarmRuleModal(false)} 
                    destroyOnClose={true}
                    footer={null} 
                    closable={false}
                    width={1000}
                    height={600}
                    >
                    <CreateAlarmRuleWizard 
                        alarmRuleId={editingAlarmRuleId}
                        onClose={()=> setOpenCreateAlarmRuleModal(false)} 
                        onComplete={()=> {
                            setOpenCreateAlarmRuleModal(false); 
                            loadAlarmRuleViews(); 
                        }}/>
                </Modal>
            </ToolBarWrapper>
            <TableWrapper>
                <Table 
                    rowKey={(record)=> record.alarmRule.id}
                    columns={columns} 
                    dataSource={filteredAlarmRuleViews}
                    loading={loading}
                />
            </TableWrapper>
        </AlarmRuleManagementWrapper>
    );
}

export default AlarmRuleManagement;
